/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstantLoginRequestBody
 */
export interface InstantLoginRequestBody {
    /**
     * 
     * @type {string}
     * @memberof InstantLoginRequestBody
     */
    token: string;
}

export function InstantLoginRequestBodyFromJSON(json: any): InstantLoginRequestBody {
    return InstantLoginRequestBodyFromJSONTyped(json, false);
}

export function InstantLoginRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstantLoginRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function InstantLoginRequestBodyToJSON(value?: InstantLoginRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

